export default "__VITE_ASSET__BvlYLQoF__"